import React from 'react'
import StaticHeader from './StaticHeader';
import StaticFooter from './StaticFooter';
import ScrollTrackingContentsTable from './ScrollTrackingContentsTable';


let data = [{id:'General-Information',title:"General Information",content:[`All orders are subject to service availability. If a service is unavailable at the time you place your order, we will notify you and refund you the total amount of your order, using the original method of payment`]},
{id:'Delivery-Time',title:"Delivery Time",content:[`For walk-ins, kindly visit a selected partner's location within their opening hour, preferably 30 minutes before close of business.`,
`For home sample collection, our partner will contact you and confirm the exact time they will be visiting you for home sample collection.`,
`Unless there are exceptional circumstances, partners make every effort to fulfill your home service request within 24 business hours of the date of your order. Business day means Monday to Friday, except holidays.
`
]}
]
function ServicePage() {
    return (
        <>
            <StaticHeader />
            <div className='service-container'>
                <div className='service-banner'>
                    <div className='title-align'> Service Delivery Policy </div>
                </div>
            </div>
           <div>
               <ScrollTrackingContentsTable data={data}/>
               </div>
            <StaticFooter />
        </>
    
    )
}

export default ServicePage
